// Tailwind는 동적으로 조합한 클래스명을 인식하지 못하므로 전체 클래스명으로 매핑
const BG_CLASS = {
  white: 'bg-white',
  gray1: 'bg-gray1',
};
const XL_BG_CLASS = {
  white: 'xl:bg-white',
  gray0: 'xl:bg-gray0',
  gray1: 'xl:bg-gray1',
};
const PADDING_X_CLASS = { 0: 'px-0', 5: 'px-5' };
const PADDING_Y_CLASS = { 0: 'pt-0', 6: 'pt-6' };

interface NormalPageProps {
  children: React.ReactNode;
  bgColor?: keyof typeof BG_CLASS;
  xlBgColor?: keyof typeof XL_BG_CLASS;
  paddingY?: keyof typeof PADDING_Y_CLASS;
  paddingX?: keyof typeof PADDING_X_CLASS;
  className?: string;
  /** 헤더 없이 단독으로 렌더링되는 라우트는 false. 헤더 높이만큼 빼지 않고 화면 전체를 사용한다. */
  hasHeader?: boolean;
}
/** xl 미만 좌우/상단 여백, 배경색, 최소 높이를 갖는 기본 페이지 래퍼. 폭 제한 없음 (타이틀은 NormalPageTitle 사용) */
export const NormalPage: React.FC<NormalPageProps> = ({
  children,
  bgColor = 'white',
  xlBgColor = 'white',
  paddingX = 5,
  paddingY = 6,
  className,
  hasHeader = true,
}) => {
  const minHeight = hasHeader ? 'min-h-normal xl:min-h-normal_pc' : 'min-h-dvh';

  return (
    <div
      className={`relative ${PADDING_X_CLASS[paddingX]} ${PADDING_Y_CLASS[paddingY]} xl:p-0 ${BG_CLASS[bgColor]} ${XL_BG_CLASS[xlBgColor]} ${minHeight} ${className ?? ''}`}
    >
      {children}
    </div>
  );
};
